import React, {FC, useState, useEffect} from 'react';
import {Button, Modal, Dimmer, Loader, ModalProps, Dropdown} from 'semantic-ui-react';
import {api, useApi} from '../api/api';
import {Config as ApiConfig} from "../api/configs";
import Uploader from "./Uploader";
import MessageWindow from "./MessageWindow";

interface Props extends ModalProps {
    onClick: () => void;
}


const InjectionEventWindow: FC<Props> = (props) => {

    const {onClick} = props;
    const configsApi = useApi(api.configs);
    const eventsApi = useApi(api.events);

    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState<ApiConfig[]>([]);
    const [config, setConfig] = useState<any>('');
    const [message, setMessage] = useState<any>('');


    useEffect(() => {
        load()
    }, []);

    const load = () => {
        setLoading(true);
        configsApi
            .index()
            .then(rows => {
                setRows(rows ?? []);
            })
            .catch(e => console.error(e))
            .finally(() => setLoading(false));
    }

    const configOptions = rows.map(item => {
        return {value: item.source, text: item.srckey?.split('/').reverse()[0]};
    });

    const upload = async (files: File[]) => {
        setLoading(true);
        const selectedFile = files[0]
        if (selectedFile && config) {
            eventsApi.create_test_event(selectedFile, config)
                .then(() => {
                })
                .catch(e => console.error(e))
                .finally(() => onClick());
        } else if (!config) {
            setMessage('No config selected');
        } else {
            setMessage('No file selected');
        }
    }

    return (
        <div>
            <Modal
                size='large'
                style={{minWidth: '70%', maxWidth: '95%'}}
                open={true}
                onClose={onClick}
                closeOnDimmerClick={false}
                closeOnEscape={false}
            >
                <Modal.Header>Create test event</Modal.Header>
                <Modal.Content>
                    {loading ?
                        <Dimmer inverted active={true}><Loader/></Dimmer> :
                        <>
                            <Dropdown
                                placeholder='Select Config'
                                fluid
                                search
                                selection
                                options={configOptions}
                                onChange={(event, {value}) => setConfig(value)}
                                value={config}
                            />
                        </>
                    }
                </Modal.Content>

                <Modal.Actions>
                    <Uploader onUpload={upload}/>
                    <Button circular onClick={onClick}>Close</Button>
                </Modal.Actions>
            </Modal>

            {
                message &&
                <MessageWindow
                    message={message}
                    onClose={() => setMessage('')}
                />
            }
        </div>
    )
}

export default InjectionEventWindow;
